import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=331e44b7&scoped=true&"
import script from "./TextSection.vue?vue&type=script&lang=ts&"
export * from "./TextSection.vue?vue&type=script&lang=ts&"
import style0 from "./TextSection.vue?vue&type=style&index=0&id=331e44b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e44b7",
  null
  
)

export default component.exports